import moment from 'moment-timezone'

const initialState = {
    Schedule: null,
    Team: null,
    ManagementUnit: null,
    agent: null,
    selectedStartDate: moment().isoWeekday(1),
    selectedEndDate: moment().isoWeekday(7),
    MUs: [],
    AgentSchedules: [],
    WeekHeaders: [],
    StartScheduledDayKey: moment().isoWeekday(1).format("MM/DD/YYYY"),
    EndScheduledDayKey: moment().isoWeekday(7).format("MM/DD/YYYY")
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/schedules/redux/initialState.js